import StatementSummary from './StatementSummary';

export default StatementSummary;
